var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mAsyncModal',{attrs:{"display":_vm.display,"focusId":_vm.focusId,"tooltip":_vm.tooltip,"description":_vm.description,"onCancel":_vm.onCancel,"onConfirm":_vm.onConfirm,"confirmButtonIcon":"fa-trash","confirmButtonType":_vm.componentTheme.Danger,"confirmButtonTitle":"Delete","title":"Delete"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }